import React from 'react'
import { Search } from 'lucide-react'
import { Input } from '@/components/ui/input'

interface SearchQueryProps {
  searchQuery: string
  onSearchChange: (query: string) => void
  placeholder?: string
}

export const SearchQuery: React.FC<SearchQueryProps> = ({
  searchQuery,
  onSearchChange,
  placeholder = "Buscar..."
}) => {
  return (
    <div className="relative w-full">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
      <Input
        placeholder={placeholder}
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        className="pl-10 bg-white"
      />
    </div>
  )
}
